export default __webpack_public_path__ + "images/ID.2846a40.png";